import React from 'react'
import Loader from 'react-loader-spinner'
import './button.scss'

const colorClass = {
  [`purple`]: 'f-btn-act--purple',
  [`pink`]: 'f-btn-act--pink',
  [`blue`]: 'f-btn-act--blue',
  [`dark-purple`]: 'f-btn-act--dark-purple',

}

const Button = ({
  className,
  color,
  outlined,
  children,
  isLoading,
  href,
  ...restProps
}) => {
  if (!isLoading) {
    return href ? (
      <a
        className={`f-btn-act ${colorClass[color]} ${
          outlined ? 'f-btn-act--outlined' : ''
        } ${children}  ${className ? className : ''}
      `}
        {...restProps}
        href={href}
      >
        {children}
      </a>
    ) : (
      <button
        className={`f-btn-act ${colorClass[color]} ${
          outlined ? 'f-btn-act--outlined' : ''
        } ${children}  ${className ? className : ''}
      `}
        {...restProps}
      >
        {children}
      </button>
    )
  } else {
    return (
      <div className="f-loader-container-act">
        <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
      </div>
    )
  }
}

export default Button
